<template>
  <appPanel class="app-panel" :width="720" :isExpand="visible" @cancel="closeDialog" :title="panelTitle">
    <el-scrollbar class="add-invitation">
      <el-form ref="form" :model="addForm" :rules="addFormRules" label-width="110px" label-suffix=":">
        <el-row>
          <el-col :span="11">
            <el-form-item label="上传人脸照片" prop="fileCode">
              <el-upload ref="upload" class="avatar-uploader" action="common/file/batchFileload.json"
                :show-file-list="false" :on-remove="handleVisitorRemove" :on-change="handleVisitorChange"
                :on-success="handleVisitorSuccess" :before-upload="beforeAvatarUpload"
                accept="image/png, image/jpg, image/jpeg, image/bpm" name="files" :auto-upload="true">
                <img class="avatar" v-if="addForm.fileCode" :src="getImgPath(addForm.fileCode)" alt=""
                  style="width: 148px; height: 148px" />
                <i v-else class="el-icon-plus avatar-uploader-icon el-upload--picture-card"></i>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="上传有效证件" prop="idCardFileCode">
              <el-upload ref="upload" class="avatar-uploader" action="common/file/batchFileload.json"
                :show-file-list="false" :on-remove="handleIdCardRemove" :on-change="handleIdCardChange"
                :on-success="(e) => handleIdCardSuccess(e, 'visitor')" :before-upload="beforeAvatarUpload"
                accept="image/png, image/jpg, image/jpeg, image/bpm" name="files" :auto-upload="true">
                <img class="avatar" v-if="addForm.idCardFileCode" :src="getImgPath(addForm.idCardFileCode)" alt=""
                  style="width: 148px; height: 148px" />
                <i v-else class="el-icon-plus avatar-uploader-icon el-upload--picture-card"></i>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <!-- <el-col :span="24">
            <el-form-item label="上传有效证件" prop="idCardFileCode">
              <el-upload
                ref="upload"
                class="avatar-uploader"
                action="common/file/batchFileload.json"
                :show-file-list="false"
                :on-remove="handleIdCardRemove"
                :on-change="handleIdCardChange"
                :on-success="handleIdCardSuccess"
                :before-upload="beforeAvatarUpload"
                accept="image/png, image/jpg, image/jpeg, image/bpm"
                name="files"
                :auto-upload="true"
                :disabled="type == 'detail' || type === 'audit'"
              >
                <img
                  class="avatar"
                  v-if="addForm.idCardFileCode"
                  :src="getImgPath(addForm.idCardFileCode)"
                  alt=""
                  style="width: 148px; height: 148px"
                />
                <i
                  v-else
                  class="el-icon-plus avatar-uploader-icon el-upload--picture-card"
                ></i>
              </el-upload>
            </el-form-item>
          </el-col> -->
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="姓名" prop="name" label-position="left">
              <el-input v-if="type == 'add' || type === 'edit' || type === 'again'" v-model="addForm.name"
                placeholder="请输入姓名"></el-input>
              <span v-else>{{ addForm.name }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="性别" prop="sex" label-position="left">
              <div v-if="type == 'add' || type === 'edit' || type === 'again'">
                <el-radio v-model="addForm.sex" label="0" style="color: 'c0c0c0'">男</el-radio>
                <el-radio v-model="addForm.sex" label="1" style="color: 'c0c0c0'">女</el-radio>
              </div>

              <!-- <el-radio
                v-if="type == 'add' || type === 'edit'||type==='again'"
                v-model="addForm.name"
                placeholder="请选择性别"
              ></el-radio> -->
              <span v-else>{{ addForm.sex === "0" ? "男" : "女" }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :span="24">
            <el-form-item label="身份证号" prop="idCard">
              <el-input
                v-if="type == 'add' || type === 'edit'||type==='again'"
                v-model="addForm.idCard"
                placeholder="请输入身份证号"
              ></el-input>
              <span v-else>{{ addForm.idCard }}</span>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row>
          <el-col :span="11">
            <el-form-item label="手机号" prop="phone">
              <el-input v-if="type == 'add' || type === 'edit' || type === 'again'" v-model="addForm.phone"
                placeholder="请输入手机号码"></el-input>
              <span v-else>{{ addForm.phone }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="身份证号" prop="idCard">
              <el-input v-if="type == 'add' || type === 'edit' || type === 'again'" v-model="addForm.idCard"
                placeholder="请输入身份证号"></el-input>
              <span v-else>{{ addForm.idCard }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="23">
            <el-form-item label="是否有车" prop="isCar" label-position="left">
              <div v-if="type == 'add' || type === 'edit' || type === 'again'">
                <el-radio v-model="addForm.isCar" label="0">否</el-radio>
                <el-radio v-model="addForm.isCar" label="1">是</el-radio>
              </div>

              <!-- <el-radio
                v-if="type == 'add' || type === 'edit'||type==='again'"
                v-model="addForm.name"
                placeholder="请选择性别"
              ></el-radio> -->
              <span v-else>{{ plateCodeString || "否" }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="addForm.isCar == '1'">
          <el-col :span="20">
            <el-form-item>
              <div class="car">
                <div class="car-list" v-for="(item, index) in appointmentVehicleList" :key="item.plateCode">
                  <div class="car-top" style="display: flex; margin-bottom: 10px;">
                    <div class="car-title">随行车辆{{ index + 1 }}：</div>
                    <el-input v-model="item.plateCode" placeholder="请输入车牌号" style="width: 180px;"></el-input>
                    <div class="btn" style="display: flex; align-items: center;">
                      <div class="btn-span" @click="handleAddCar">+</div>
                      <div class="btn-span" @click="handleDeleteCar(index)" v-if="appointmentVehicleList.length > 1">
                        -
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="访客类型" prop="visitorTypeCode">
              <el-select v-if="type == 'add' || type === 'edit' || type === 'again'" v-model="addForm.visitorTypeCode">
                <el-option v-for="item in visitorTypeList" :key="item.visitorTypeCode" :label="item.visitorTypeName"
                  :value="item.visitorTypeCode">
                </el-option>
              </el-select>
              <!-- <el-input
                v-if="type == 'add' || type === 'edit'||type==='again'"
                type="textarea"
                v-model="addForm.visitorReason"
                placeholder="请输入来访目的"
              ></el-input> -->
              <span v-else>{{ plateCodeString }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :span="12">
            <el-form-item label="被拜访人" prop="appointmentReceptionistList">
              <el-select
                v-if="type == 'add' || type === 'edit'||type==='again'"
                multiple
                v-model="addForm.appointmentReceptionistList"
              >
                <el-option
                  v-for="item in personList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            
              <span v-else>{{ plateCodeString }}</span>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row>
          <el-col :span="24">
            <el-form-item label="来访目的" prop="visitorReason">
              <el-input v-if="type == 'add' || type === 'edit' || type === 'again'" type="textarea"
                v-model="addForm.visitorReason" placeholder="请输入来访目的"></el-input>
              <span v-else>{{ addForm.visitorReason }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :span="11">
            <el-form-item label="接口人手机号" prop="receiverPhone">
              <el-input
                v-model="addForm.receiverPhone"
                @change="getNameByPhone(addForm.receiverPhone)"
                placeholder="请输入接口人手机号码"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="接口人" prop="receiverNames">
              <el-input
                :disabled="true"
                v-if="type == 'add' || type === 'edit'||type==='again'"
                v-model="addForm.receiverNames"
                placeholder="接口人姓名根据手机号回填"
              ></el-input>
              <span v-else>{{ addForm.receiverNames }}</span>
            </el-form-item>
          </el-col>
        </el-row> -->

        <el-row>
          <el-col :span="24">
            <el-form-item label="访问时间" prop="visitDate">
              <el-date-picker v-if="type == 'add' || type === 'edit' || type === 'again'" v-model="addForm.visitDate"
                @change="handleDateChange" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期">
              </el-date-picker>
              <span v-else>{{ addForm.enterTime }}~{{ addForm.exitTime }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="type == 'detail' || type === 'audit'">
          <el-col :span="12">
            <el-form-item label="登记时间" prop="createTime">
              {{ addForm.createTime }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="人员通行闸机" prop="turnstileGateThirdDeviceIdList">
              <el-select v-model="addForm.turnstileGateThirdDeviceIdList" :disabled="true" multiple>
                <el-option v-for="item in personAuthList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="addForm.isCar == '1'">
          <el-col :span="24">
            <el-form-item label="停车场" prop="parkinglotCode">
              <el-select v-model="addForm.parkinglotCode" :disabled="true">
                <el-option v-for="item in carLotList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="addForm.isCar == '1'">
          <el-col :span="24">
            <el-form-item label="车辆通行闸机" prop="vehicleBarrierThirdDeviceIdList">
              <el-select v-model="addForm.vehicleBarrierThirdDeviceIdList" :disabled="true" multiple>
                <el-option v-for="item in carAuthList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input v-model="addForm.remark" type="textarea"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="follow-list" v-for="(item, index) in addForm.partnterList" :key="item.id">
          <div class="flex-row">
            <div class="list-title" style="margin-left: 10px;font-size: 18px;margin-bottom: 10px;">随行人员{{ index + 1 }}
            </div>
            <el-tooltip content="删除">
              <span class="delete-btn" @click="handleRemovePartner(index)"
                v-if="addForm.partnterList.length > 0">X</span></el-tooltip>
          </div>
          <el-row>
            <el-col :span="11">
              <el-form-item label="上传人脸照片" :prop="'partnterList.' + index + '.partnerUrl'"
                :rules="{ required: true, message: '请上传人脸照片', trigger: 'blur' }">
                <el-upload :disabled="type == 'detail' || type === 'audit'" ref="upload" class="avatar-uploader"
                  action="common/file/batchFileload.json" :show-file-list="false" :on-remove="handlePartnerRemove"
                  :on-change="handlePartnerChange" :on-success="(e) => handlePartnerSuccess(e, index)"
                  :before-upload="beforeAvatarUpload" accept="image/png, image/jpg, image/jpeg, image/bpm" name="files"
                  :auto-upload="true">
                  <img class="avatar" v-if="item.partnerUrl" :src="getImgPath(item.partnerUrl)" alt=""
                    style="width: 148px; height: 148px" />
                  <i v-else class="el-icon-plus avatar-uploader-icon el-upload--picture-card"></i>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="上传有效证件" :prop="'partnterList.' + index + '.idCardFileCode'"
                :rules="{ required: true, message: '请上传有效证件', trigger: 'blur' }">
                <el-upload ref="upload" class="avatar-uploader" action="common/file/batchFileload.json"
                  :show-file-list="false" :on-remove="handleIdCardRemove" :on-change="handleIdCardChange"
                  :on-success="(e) => handleIdCardSuccess(e, 'follower', index)" :before-upload="beforeAvatarUpload"
                  accept="image/png, image/jpg, image/jpeg, image/bpm" name="files" :auto-upload="true"
                  :disabled="type == 'detail' || type === 'audit'">
                  <img class="avatar" v-if="item.idCardFileCode" :src="getImgPath(item.idCardFileCode)" alt=""
                    style="width: 148px; height: 148px" />
                  <i v-else class="el-icon-plus avatar-uploader-icon el-upload--picture-card"></i>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="11">
              <el-form-item label="姓名" :prop="'partnterList.' + index + '.name'"
                :rules="{ required: true, message: '请输入姓名', trigger: 'blur' }" label-position="left">
                <el-input v-if="type == 'add' || type === 'edit' || type === 'again'" v-model="item.name"
                  placeholder="请输入姓名"></el-input>
                <span v-else>{{ item.name }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="性别" prop="sex">
                <el-radio v-model="item.sex" label="0">男</el-radio>
                <el-radio v-model="item.sex" label="1">女</el-radio>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="11">
              <el-form-item label="身份证号" :prop="'partnterList.' + index + '.idCard'"
                :rules="{ required: true, message: '请输入身份证号', trigger: 'blur' }">
                <el-input v-if="type == 'add' || type === 'edit' || type === 'again'" class="width200"
                  v-model="item.idCard" placeholder="请输入身份证号"></el-input>
                <span v-else>{{ item.idCard }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="手机号" :prop="'partnterList.' + index + '.phone'"
                :rules="{ required: true, message: '请输入手机号码', trigger: 'blur' }">
                <el-input v-if="type == 'add' || type === 'edit' || type === 'again'" v-model="item.phone"
                  placeholder="请输入手机号码"></el-input>
                <span v-else>{{ item.phone }}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="audit-info" v-if="type === 'audit'">
          <div class="aduit-title">审批信息</div>
          <el-row>
            <el-col :span="11">
              <el-form-item label="审批人">
                <span>{{ workFlowInfo.operatorName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="审批结果">
                {{ getStatusLabel(workFlowInfo.status) }}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="11">
              <el-form-item label="审批时间">
                <span>{{ workFlowInfo.operatTime }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="访客类型">
                {{ addForm.visitorTypeName }}
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="add-btn" @click="handleAddPartner" v-if="type == 'add' || type === 'edit' || type === 'again'">
          + 增加随行人员
        </div>
      </el-form>
    </el-scrollbar>
    <div slot="footer" class="dialog-footer">
      <el-button type="info" :loading="btnLoading" @click="closeDialog()">{{
        btnLoading ? "提交中" : $t("accountGroup.button.cancel")
      }}</el-button>
      <el-button v-if="type == 'add' || type === 'edit' || type === 'again'" type="primary" :loading="btnLoading"
        @click="saveForm()">{{ btnLoading ? "提交中" : $t("accountGroup.button.save") }}</el-button>
    </div>
  </appPanel>
</template>

<script>
import { Bus, Cache } from "$utils";
import appPanel from "@src/components/business/app-panel/index.vue";
import { api } from "../api.js";
import { Dic } from "@src/common/utils";
import utils from "@src/common/utils";

// import { getPersonList } from '@/modules/access/api'
// import { addVisit, showUserList, showPassPersonList } from '../api'

export default {
  name: "addInvitationComponent",
  // inject: ["openImage"],
  components: { appPanel },
  data() {
    return {
      page: {
        pageNum: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      addForm: {
        visitDate: [],
        partnterList: [],
        fileCode: "",
        idCardFileCode: "",
        name: "",
        phone: "",
        idCard: "",
        isCar: "0",
        sex: "",
        remark: "",
        turnstileGateThirdDeviceIdList: [],
        parkinglotName: "",
        visitorReason: "",
        parkinglotCode: "",
        vehicleBarrierThirdDeviceIdList: [],
      },
      appointmentVehicleList: [{ plateCode: "" }],
      visitorReceiverName: "",
      btnLoading: false,
      // visitDates: [],
      addFormRules: {
        visitDate: [
          {
            required: true,
            message: "请选择访问时间",
            trigger: ["blur", "change"],
          },
        ],
        name: [
          {
            required: true,
            message: "请输入姓名",
            trigger: ["blur", "change"],
          },
        ],
        idCard: [
          {
            required: true,
            message: "请输入身份证号",
            trigger: ["blur", "change"],
          },
        ],
        partnerUrl: [
          {
            required: true,
            message: "请上传人脸照片",
            trigger: ["blur", "change"],
          },
        ],
        idCardFileCode: [
          {
            required: true,
            message: "请上传有效证件照片",
            trigger: ["blur", "change"],
          },
        ],
        visitorTypeCode: [
          {
            required: true,
            message: "请选择访客类型",
            trigger: ["blur", "change"],
          },
        ],
        // appointmentReceptionistList:[ {
        //     required: true,
        //     message: "请选择访客类型",
        //     trigger: ["blur", "change"],
        //   },],
        phone: [
          {
            required: true,
            message: "请输入手机号",
            trigger: ["blur", "change"],
          },
        ],
        // plateCode: [
        //   {
        //     required: false,
        //     message: "请输入车牌号",
        //     trigger: ["blur", "change"],
        //   },
        // ],
        fileCode: [
          {
            required: true,
            message: "请上传人脸照片",
            trigger: ["blur", "change"],
          },
        ],
        receiverName: [
          {
            required: true,
            message: "请输入接待人",
            trigger: ["blur", "change"],
          },
        ],
        visitorReason: [
          {
            required: true,
            message: "请输入邀约事由",
            trigger: ["blur", "change"],
          },
        ],
        passPersonList: [
          {
            required: true,
            message: "请选择访客",
            trigger: ["blur", "change"],
          },
        ],
        vehicleBarrierThirdDeviceIdList: [
          {
            required: true,
            message: "请选择车辆通行道闸",
            trigger: ["blur", "change"],
          },
        ],
        turnstileGateThirdDeviceIdList: [
          {
            required: true,
            message: "请选择人员通行闸机",
            trigger: ["blur", "change"],
          },
        ],
      },
      multipleSelection: [],
      tableColumns2: [
        {
          label: "照片",
          prop: "imageUrl",
        },
        // {
        //   label: '人员类型',
        //   prop: 'outPersonType'
        // },
        {
          label: "姓名",
          prop: "personName",
        },
        {
          label: "性别",
          prop: "personSex",
          // width: 60
        },
        {
          label: "联系电话",
          prop: "personPhone",
        },
        {
          label: "证件号码",
          prop: "idCard",
        },
      ],
      userList: [],
      pageNo: 1,
      pageSize: 20,
      total: 0,
      tableLoading: false,
      outPersonType: "",
      personName: "",
      personPhone: "",
      sexArr: [
        {
          value: "0",
          label: "男",
        },
        {
          value: "1",
          label: "女",
        },
      ],
      staffArr: [
        {
          label: "普通访客",
          value: "0",
        },
        {
          label: "施工人员",
          value: "1",
        },
        {
          label: "员工家属",
          value: "2",
        },
        {
          label: "货运人员",
          value: "3",
        },
        {
          label: "其它临员",
          value: "4",
        },
      ],
      multipleSelections: [],
      visitDates: [],
      receptionist: "",
      invitationReason: "",
      receptionistList: [],
      visible: false,
      addVisible: false,
      tableColumns: [
        {
          label: "序号",
          prop: "index",
          width: 80,
        },
        {
          label: "照片",
          prop: "imageUrl",
        },
        {
          label: "访客姓名",
          prop: "personName",
        },
        {
          label: "性别",
          prop: "personSex",
          width: 60,
        },
        {
          label: "手机号码",
          prop: "personPhone",
        },
        {
          label: "身份证号",
          prop: "idCardNo",
        },
        {
          label: "车辆号牌",
          prop: "plateNumber",
        },
      ],
      tableData: [
        {
          id: "",
          imageUrl: "",
          personName: "孙文强",
          personSex: "男",
          personPhone: "138****3900",
          idCardNo: "320***********5516",
          plateNumber: "苏A4P888",
        },
      ],
      selectedList: [],
      panelTitle: "",
      type: "",
      appointmentReceptionistList: [],
      visitorTypeList: [],
      plateCodeString: "",
      workFlowInfo: {},
      partnterListCode: [],
      personAuthList: [],
      carAuthList: [],
      personList: [],
      carLotList: [],
      saveBtn: false,
    };
  },
  mounted() {
    // this.visible = true;
    // this.getReceiverList();
    // this.getVisitorList();
    // this.getPeopleAuthList();
  },
  methods: {
    getLotList() {
      let deviceName = Cache.get("SYS_PARKINGLOT");

      this.$fetch(api.queryDepotLotList, {}).then((res) => {
        if (!res.success) {
          this.$message.error(res.msgContent);
        }

        this.carLotList = res.returnObj
          .map((item) => {
            return {
              label: item.parkingLot,
              value: item.parkingLotCode,
            };
          })
          .filter((el) => el.label === deviceName);

        this.addForm.parkinglotCode = this.carLotList[0].value;
        this.addForm.parkinglotName = this.carLotList[0].label;
        // console.log(
        //   this.carLotList,
        //   this.addForm.parkinglotCode,
        //   ">>>>this.carLotList"
        // );
      });
    },
    getPersonList() {
      this.$fetch(api.queryPersonListApi, {
        //20230707000001
        departmentCodeList: ["20230707000001"],
        pageNum: 1,
        pageSize: 10,
        personnelType: 1,
      }).then((res) => {
        if (!res.success) {
          this.$message.error(res.msgContent);
        }
        this.personList = res.returnObj.list.map((item) => {
          return {
            label: item.name,
            value: item.workNo,
          };
        });
      });
    },
    getPeopleAuthList() {
      this.addForm.turnstileGateThirdDeviceIdList = [];
      let deviceName = Cache.get("SYS_TURNSTILE");

      let params = { ...this.page, deviceName };
      this.$fetch(api.queryPersonDevice, params).then((res) => {
        if (!res.success) {
          this.$message.error(res.msgContent);
        }
        this.personAuthList = res.returnObj.list.map((item) => {
          this.addForm.turnstileGateThirdDeviceIdList.push(item.thirdDeviceId);
          return {
            label: item.thirdDeviceName,
            value: item.thirdDeviceId,
          };
        });
      });
    },
    getCarAuthList() {
      this.addForm.vehicleBarrierThirdDeviceIdList = [];
      let deviceName = Cache.get("SYS_VEHICLE");
      let params = { ...this.page, deviceName };
      this.$fetch(api.queryVehicleDevice, params).then((res) => {
        if (!res.success) {
          this.$message.error(res.msgContent);
        }
        this.carAuthList = res.returnObj.list.map((item) => {
          this.addForm.vehicleBarrierThirdDeviceIdList.push(item.thirdDeviceId);
          return {
            label: item.deviceName,
            value: item.thirdDeviceId,
          };
        });
        // console.log(
        //   this.addForm.vehicleBarrierThirdDeviceIdList,
        //   this.addForm.turnstileGateThirdDeviceIdList,
        //   ">>>>>this.addForm.vehicleBarrierThirdDeviceIdList"
        // );
      });
    },
    getStatusLabel(val) {
      return Dic.findByValue("SENU080003", Number(val));
    },
    openPanel(type, data) {
      this.type = type;
      this.btnLoading = false;
      console.log(data, type, ">>>>>>open");
      this.visible = true;
      switch (type) {
        case "add":
          this.panelTitle = "新增访客邀约";
          break;
        case "edit":
          this.panelTitle = "修改访客邀约";
          this.addForm = data;
          this.addForm.visitDate = [data.enterTime, data.exitTime];
          break;
        case "again":
          this.panelTitle = "再次邀约";
          this.addForm = data;
          this.addForm.visitDate = [data.enterTime, data.exitTime];
          break;
        case "detail":
          this.panelTitle = "邀约详情查看";
          this.addForm = data;
          this.addForm.visitDate = [data.enterTime, data.exitTime];
          break;
        case "audit":
          this.panelTitle = "审批详情查看";
          this.addForm = data;
          this.addForm.visitDate = [data.enterTime, data.exitTime];
          this.queryWorkFlow(this.addForm.appointmentCode);
          break;
        default:
          this.panelTitle = "新增访客邀约";
          break;
      }
      if (
        this.addForm.appointmentVehicleList &&
        this.addForm.appointmentVehicleList.length > 0
      ) {
        this.plateCodeString = this.addForm.appointmentVehicleList.join(",");
      }
      this.getVisitorList();
      this.getPeopleAuthList();
      this.getCarAuthList();
      this.getLotList();
      this.getPersonList();
      this.$forceUpdate();
    },
    handleAddCar() {
      this.appointmentVehicleList.push({ plateCode: "", partnerUrl: "" });
    },
    handleDeleteCar(index) {
      this.appointmentVehicleList.splice(index, 1);
    },
    queryWorkFlow(appointmentCode) {
      let params = {
        appointmentCode,
      };
      this.$fetch(api.queryAppointmentWorkflow, params).then((res) => {
        if (!res.success) {
          this.$message.error(res.msgContent);
        } else {
          this.workFlowInfo = res.returnObj[1];
        }
      });
    },
    saveForm() {
      let carCodeList = [];
      this.appointmentVehicleList.forEach((item) => {
        carCodeList.push(item.plateCode);
      });
      this.$refs.form.validate((val) => {
        if (val) {
          this.btnLoading = true;
          let params = {
            appointmentReceptionistList: [],
            status: "1",
            templateCode: "200000002",
            isFactory: "0",
            isCar: this.addForm.isCar,
            isPartner: this.addForm.partnterList.length > 0 ? "1" : "0",
            turnstileGateThirdDeviceIdList:
              this.addForm.turnstileGateThirdDeviceIdList,
            name: this.addForm.name,
            phone: this.addForm.phone,
            idCard: this.addForm.idCard,
            // enterTime: "2023-08-09 10:41:31",
            // exitTime: "2023-08-09 15:41:41",
            exitTime: this.addForm.exitTime,
            enterTime: this.addForm.enterTime,
            sex: this.addForm.sex,
            fileCode: this.addForm.fileCode,
            visitorReason: this.addForm.visitorReason,
            idCardFileCode: this.addForm.idCardFileCode,
            partnerCount: this.addForm.partnterList.length,
            partnterList: this.addForm.partnterList,
            visitorTypeCode: this.addForm.visitorTypeCode,
            appointmentVehicleList: this.appointmentVehicleList || [],
            // appointmentVehicleList: carCodeList || [],
            // appointmentVehicleList: this.addForm.plateCode
            //   ? [this.addForm.plateCode]
            //   : [],
            // appointmentReceptionistList: [],
            // appointmentVehicleList: carCodeList,
            // enterTime: "2023-08-09 10:41:31",
            // exitTime: "2023-08-09 15:41:41",
            // fileCode: "group1/M00/00/05/CiiTsGTQWcCAML3yAAJmqxZFu-012.jpeg",
            // idCard: "320723199901111987",
            // idCardFileCode: "group1/M00/00/05/CiiTsGTQWcaAJKpTAAE6qDsHxyc51.jpeg",
            // isCar: "0",
            // isFactory: 0,
            // isPartner: "0",
            // name: "lhhhhh",
            // partnerCount: 0,
            // partnterList: null,
            // phone: "15295795775",
            // receiverWorkNo: "",
            // sex: "1",
            // status: "1",
            // templateCode: "200000002",
            // turnstileGateThirdDeviceIdList: ["11111"],
            // visitorReason: "11",
            // visitorTypeCode: "20230718000001",

            // plateCode:this.add
            // ...this.addForm,
          };
          console.log("add", this.addForm);
          if (this.addForm.isCar == 1) {
            params.vehicleBarrierThirdDeviceIdList =
              this.addForm.vehicleBarrierThirdDeviceIdList;
            params.parkinglotCode = this.addForm.parkinglotCode;
            params.parkinglotName = this.addForm.parkinglotName;
          }
          this.$fetch(api.addVisitorApply, params).then((res) => {
            console.log(res, ">>>>>res");
            if (!res.success) {
              this.btnLoading = false;
              this.$message.error(res.msgContent)
              return
            }
            if (res.success) {
              this.btnLoading = false;
              this.$message.success("新增成功");
              this.closeDialog();
              this.$emit("getList");
            }
            // setTimeout(() => {
            //   this.btnLoading = false;
            // }, 1500);
          });
        }
      });
      // delete this.addForm.visitDate;
    },

    closeDialog() {
      this.addForm = {};
      // this.$refs.form.resetFields();
      this.visible = false;
    },
    getImgPath(item) {
      return item ? Bus.imgPath(item) : "";
    },
    handleAddPartner() {
      this.addForm.partnterList.push({
        partnerUrl: "",
        plateCode: "",
        idCardFileCode: "",
      });
    },
    handleRemovePartner(index) {
      this.addForm.partnterList.splice(index, 1);
    },
    // 删除图片
    handleVisitorRemove(file, fileList) {
      // if (this.formState === 2) {
      //   if (file.status === "update") {
      //     let index = this.fileList.findIndex((item) => {
      //       return item.url === file.url;
      //     });
      //     this.fileList.splice(index, 1);
      //   }
      // }
      console.log("handleVisitorRemove");
    },
    handleIdCardRemove(file, fileList) {
      // if (this.formState === 2) {
      //   if (file.status === "update") {
      //     let index = this.fileList.findIndex((item) => {
      //       return item.url === file.url;
      //     });
      //     this.fileList.splice(index, 1);
      //   }
      // }
      console.log("handleIdCardRemove", file);
    },
    handlePartnerRemove(file, fileList) {
      // if (this.formState === 2) {
      //   if (file.status === "update") {
      //     let index = this.fileList.findIndex((item) => {
      //       return item.url === file.url;
      //     });
      //     this.fileList.splice(index, 1);
      //   }
      // }
      console.log("handleVisitorRemove");
    },
    handlePartnerSuccess(res, index) {
      console.log(index, res, "success>>>>>>>>");
      if (res.success) {
        this.addForm.partnterList[index].partnerUrl = res.returnObj[0].fileId;
        this.$forceUpdate();
        // this.form.fileCode = res.returnObj[0].fileId;
        // console.log("handleVisitorSuccess");
      }
    },
    handleIdCardSuccess(e, type, index) {
      if (e.success) {
        if (type === "visitor") {
          this.addForm.idCardFileCode = e.returnObj[0].fileId;
        } else {
          this.addForm.partnterList[index].idCardFileCode =
            e.returnObj[0].fileId;
        }
        console.log(e, this.addForm.partnterList, ">>>>>>e");
      }
    },
    handleVisitorSuccess(res, file, fileList) {
      if (res.success) {
        this.addForm.fileCode = res.returnObj[0].fileId;
        // this.form.fileCode = res.returnObj[0].fileId;
        // console.log("handleVisitorSuccess");
      }
    },
    getNameByPhone(phone) {
      // console.log(phone, ">>>>>>phne");

      this.$fetch(api.queryNameByPhone, { receiverPhone: phone }).then(
        (res) => {
          if (res.success) {
            this.addForm.receiverNames = res.returnObj.receiverName;
            this.addForm.receiverWorkNo = res.returnObj.workNo;
            this.appointmentReceptionistList = [res.returnObj];
            console.log(res, ">>>>res");
          }
        }
      );
    },
    // 添加图片
    handleVisitorChange(file, fileList) {
      // console.log("fileList", fileList, row);
      if (!this.validImg(file)) {
        this.deleteImg(file, fileList);
        return false;
      }
      // this.imgFileList = fileList;
      // this.form.fileCode = fileList;
      console.log("handleVisitorChange", file, fileList);
    },
    handleIdCardChange(file, fileList) {
      // console.log("fileList", fileList, row);
      if (!this.validImg(file)) {
        this.deleteImg(file, fileList);
        return false;
      }
      // this.imgFileList = fileList;
      // this.form.fileCode = fileList;
      console.log("handleVisitorChange", file, fileList);
    },
    handlePartnerChange(file, fileList) {
      // console.log("fileList", fileList, row);
      if (!this.validImg(file)) {
        this.deleteImg(file, fileList);
        return false;
      }
      // this.imgFileList = fileList;
      // this.form.fileCode = fileList;
      console.log("handleVisitorChange", file, fileList);
    },
    beforeAvatarUpload(file) {
      const isImg = [
        "image/png",
        "image/jpg",
        "image/jpeg",
        "image/bpm",
      ].includes(file.type);
      if (!isImg)
        this.$message.error("图片类型错误,只能是png/jpg/jpeg/bpm中的一种");
      return isImg;
    },
    validImg(file) {
      const fileName = file.name;
      const type = fileName.slice(fileName.indexOf(".") + 1, fileName.length);
      const imgArr = [
        "jpg",
        "png",
        "jpeg",
        "jpe",
        "dib",
        "bmp",
        "JPG",
        "PNG",
        "JPEG",
        "JPE",
        "DIB",
        "BMP",
      ];
      let isJPG = null;
      imgArr.indexOf(type) === -1 ? (isJPG = false) : (isJPG = true);

      if (!isJPG) {
        this.$message.error(this.$t("emergencyHandle.message.formatWarn"));
        return false;
      }
      const Size = 1024 * 1024 * 4;
      if (file.size > Size) {
        this.$message.error(this.$t("emergencyHandle.message.sizeWarn"));
        return false;
      }
      return true;
    },
    deleteImg(file, fileList) {
      console.log("deleImge");
    },
    handleDateChange(data) {
      console.log(data, "date");
      this.addForm.enterTime = data[0];
      this.addForm.exitTime = data[1];
    },
    // addConfirm() {
    //   console.log(this.addForm, "===thia.addForm");
    //   delete this.addForm.visitDates;
    //   let param = {
    //     pageSize: this.pageSize,
    //     pageNumber: this.pageNo,
    //     visitType: 1,
    //     ...this.addForm,
    //   };
    //   this.$emit("addInvitationConfirm", param);
    // },
    // handeVisitChange(data) {
    //   this.addForm.startTime = data[0]
    //   this.addForm.exitTime = data[1]
    //   console.log(data, '====data')
    // },
    handleRecevierChange(item, val) {
      this.addForm.visitorReceiverPhone = val.phone;
      this.addForm.visitorReceiver = val.name;
      console.log(item, val, "====change");
    },
    handleLotChange(val) {
      let arr = this.carLotList.filter((item) => item.value == val);
      this.addForm.parkinglotName = arr[0].label;
      this.addForm.parkinglotCode = val;
    },
    //邀约接待人列表
    // getReceiverList() {
    //   showUserList().then((res) => {
    //     if (!res.success) {
    //       this.$socMessage.error(res.msgContent)
    //       return
    //     }
    //     this.receptionistList = res.data.list
    //   })
    // },
    getVisitorList() {
      this.$fetch(api.getVisitorTypeListApi, {}).then((res) => {
        if (!res.success) {
          this.$message.error(res.msgContent);
          return;
        }
        this.visitorTypeList = res.returnObj;
      });
    },
    addCancel() {
      this.visible = false;
    },
    handleSelect() {
      this.userList.forEach((el, ind) => {
        this.multipleSelection.forEach((item, index) => {
          if (el.id == item) {
            this.addForm.passPersonList.push({
              personId: Number(el.id), // 人员ID
              personName: el.personName, // 人员姓名
              personSex: el.personSex, // 人员性别
              personPhone: el.personPhone, // 人员电话号码
              idCardNo: el.idCardNo, // 身份证号码
              imageUrl: el.imageUrl, // 访客头像URL
              // plateNumber: "2113213213213"
            });
          }
        });
      });
      // console.log(this.selectedList, '===select')
      this.addVisible = false;
    },
    handleSearch() {
      this.getVisitorList();
    },
    pageSizeChange(pageSize) {
      this.pageNo = 1;
      this.pageSize = pageSize;
      this.handleSearch();
    },
    pageNoChange(pageNo) {
      this.pageNo = pageNo;
      this.handleSearch();
    },
    changeSelection(val) {
      console.info("val", val);
      this.multipleSelection = val;
    },
    handleReset() {
      this.personPhone = "";
      this.personName = "";
      this.outPersonType = "";
      this.getPersonList();
    },
    // 获取人员列表
    // getPersonList() {
    //   let param = {
    //     pageNumber: this.pageNo,
    //     pageSize: this.pageSize,
    //     personPhone: this.personPhone,
    //     personName: this.personName,
    //     isOutSide: "1",
    //   };
    //   this.tableLoading = true;
    //   getPersonList(param).then((res) => {
    //     this.tableLoading = false;
    //     if (!res.success) {
    //       this.$socMessage.error(res.msgContent);
    //       return;
    //     }
    //     this.userList = res.data.list;
    //     this.pageNo = res.data.pageNum;
    //     this.pageSize = res.data.pageSize;
    //     this.total = res.data.total;
    //   });
    // },
    dealValueToLabel(value, arr) {
      let result = "";
      if (!value || !arr) {
        return result;
      } else {
        arr.forEach((item) => {
          if (item.value == value) {
            result = item.label;
          }
        });
        return result;
      }
    },
    imgPath(fileCode) {
      return fileCode ? "/bms/file/fdfs/download?fileId=" + fileCode : "";
    },
    handleDelete() {
      this.addForm.passPersonList.forEach((item, index) => {
        this.multipleSelections.forEach((el) => {
          console.log(item, el, "====dele");
          if (item.personId == el) {
            this.addForm.passPersonList.splice(index, 1);
          }
        });
      });
    },

    changeSelections(val) {
      console.info("val", val);
      this.multipleSelections = val;
    },

    // handleOpenPic(url) {
    //   this.openImage(url);
    // },
  },
};
</script>

<style lang='scss' scoped>
.delete-btn {
  cursor: pointer;
  margin-left: 20px;
  color: #407aee;
}

.flex-row {
  display: flex;
}

.width200 {
  width: 200px;
}

.add-btn {
  // width: 80%;
  text-align: center;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  border: 2px dashed #c0c0c0;
  border-radius: 2px;
  cursor: pointer;
  margin-left: 16%;
  margin-right: 2%;
}

.btn-span {
  cursor: pointer;
  font-size: 26px;
  width: 23px;
  margin-left: 10px;
}

.add-invitation {
  display: flex;
  flex-direction: column;

  .info-title {
    color: #fff;
    border-left-width: 3px;
    border-left-style: solid;
    padding-left: 10px;
    border-left-color: #407aee;
  }

  &__basic {
    display: flex;
    flex-wrap: wrap;
  }

  &__opt {
    display: flex;
    margin-bottom: 16px;

    .soc_button+.soc_button {
      margin-left: 16px;
    }
  }

  &__abnormal {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    height: 250px;

    .info-title {
      margin-bottom: 16px;
    }
  }

  &__record {
    display: flex;
    flex-direction: column;
    height: 300px;

    .info-title {
      margin-bottom: 16px;
    }
  }
}
</style>
